import dynamic from 'next/dynamic'

export const DynamicGlobalHomePageCartDrawer = dynamic(
  () => import('.').then((mod) => mod.GlobalHomePageCartDrawer),
  { ssr: false },
)
